/* Shopify predictive search: the platform supplies prefix and typo-tolerant matches. */
if (!customElements.get('besneaker-search')) {
  customElements.define('besneaker-search', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[role="combobox"]');
      this.panel = this.querySelector('.hero-search__panel');
      this.list = this.querySelector('[role="listbox"]');
      this.status = this.querySelector('[role="status"]');
      this.index = -1;
      this.sequence = 0;
      this.input.addEventListener('input', () => {
        this.cancel(); this.close();
        const q = this.input.value.trim();
        if (!q) { this.status.textContent = ''; return; }
        this.timer = setTimeout(() => this.search(q), 250);
      });
      this.input.addEventListener('focus', () => {
        if (this.list.children.length && this.term === this.input.value.trim()) this.open();
      });
      this.addEventListener('focusout', e => { if (!this.contains(e.relatedTarget)) { this.cancel(); this.close(); } });
      this.input.addEventListener('keydown', e => {
        if (e.key === 'Escape') { this.cancel(); this.close(); return; }
        if (this.panel.hidden) return;
        const options = Array.from(this.list.children);
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          this.index = (this.index + (e.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
          options.forEach((el, i) => el.setAttribute('aria-selected', String(i === this.index)));
          this.input.setAttribute('aria-activedescendant', options[this.index].id);
          options[this.index].scrollIntoView({block:'nearest'});
        } else if (e.key === 'Enter' && this.index >= 0) {
          e.preventDefault(); options[this.index].querySelector('a').click();
        }
      });
    }
    disconnectedCallback() { this.cancel(); }
    cancel() { clearTimeout(this.timer); this.controller?.abort(); this.sequence++; }
    close() {
      this.panel.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant'); this.index = -1;
      Array.from(this.list.children).forEach(el => el.setAttribute('aria-selected', 'false'));
    }
    open() { this.panel.hidden = false; this.input.setAttribute('aria-expanded', 'true'); }
    searchURL(q) {
      const url = new URL(this.dataset.searchUrl, location.origin);
      url.search = new URLSearchParams({q, type:'product', 'options[prefix]':'last'}).toString();
      return url.href;
    }
    add(title, href, image) {
      const li = document.createElement('li');
      li.id = this.list.id + '-' + this.list.children.length;
      li.setAttribute('role','option'); li.setAttribute('aria-selected','false');
      const a = document.createElement('a'); a.href = href; a.tabIndex = -1;
      // Keep the input focused for mouse selection; touch scrolling stays native.
      a.addEventListener('mousedown', e => e.preventDefault());
      a.addEventListener('click', () => {
        const target = new URL(a.href, location.origin);
        if (!target.pathname.includes('/products/')) return;
        try {
          sessionStorage.setItem('bn-product-search-return', JSON.stringify({
            target: target.pathname,
            back: this.searchURL(this.input.value.trim()),
            time: Date.now()
          }));
        } catch (error) {}
      });
      if (image) { const img = document.createElement('img'); img.src = image; img.alt = ''; img.width = 48; img.height = 48; img.loading = 'lazy'; a.append(img); }
      const text = document.createElement('span'); text.textContent = title; a.append(text); li.append(a); this.list.append(li);
    }
    async search(q) {
      const sequence = ++this.sequence;
      this.controller = new AbortController();
      this.status.textContent = 'Buscando sugerencias…';
      try {
        const url = new URL(this.dataset.suggestUrl + '.json', location.origin);
        url.search = new URLSearchParams({q, 'resources[type]':'query,product', 'resources[limit]':'6', 'resources[limit_scope]':'each', 'resources[options][unavailable_products]':'last'}).toString();
        const response = await fetch(url, {signal:this.controller.signal});
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        if (sequence !== this.sequence || this.input.value.trim() !== q) return;
        const results = data.resources.results;
        this.list.replaceChildren(); this.term = q; this.index = -1;
        (results.queries || []).slice(0,3).forEach(item => this.add('Sugerencia: ' + item.text, this.searchURL(item.text)));
        (results.products || []).forEach(item => this.add(item.title, item.url, item.featured_image?.url || item.image));
        const count = this.list.children.length;
        this.add(count ? 'Ver todos los resultados para “' + q + '” →' : 'Sin sugerencias. Buscar “' + q + '” →', this.searchURL(q));
        this.status.textContent = count ? count + ' sugerencias disponibles. Usa las flechas para navegar.' : 'No hay sugerencias. Presiona Enter para buscar en el catálogo.';
        if (document.activeElement === this.input) this.open();
      } catch (error) {
        if (error.name === 'AbortError' || sequence !== this.sequence) return;
        this.list.replaceChildren(); this.term = q;
        this.add('Buscar “' + q + '” en todo el catálogo →', this.searchURL(q));
        this.status.textContent = 'Sugerencias no disponibles. Puedes realizar la búsqueda.';
        if (document.activeElement === this.input) this.open();
      }
    }
  });
}
